import { render, staticRenderFns } from "./AfterSalesList.vue?vue&type=template&id=2f6f4b75&scoped=true"
import script from "./AfterSalesList.vue?vue&type=script&lang=js"
export * from "./AfterSalesList.vue?vue&type=script&lang=js"
import style0 from "./AfterSalesList.vue?vue&type=style&index=0&id=2f6f4b75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6f4b75",
  null
  
)

export default component.exports